import { map } from 'ramda';
import { setCookieValue } from '@engage/cookies';
export var toSwitchApiEnv = function toSwitchApiEnv(cache, env, maxAge) {
  setCookieValue({
    key: 'API_ENVIRONMENT',
    value: env,
    maxAge: maxAge
  });
  clearCache(cache);
};
export var clearCache = function clearCache(cache) {
  if (isMap(cache)) {
    var keys = Array.from(cache.keys());
    map(function (key) {
      return cache.delete(key);
    }, keys);
  } else {
    throw new Error('Cannot clear cache because it is not a Map');
  }
};

var isMap = function isMap(v) {
  return v instanceof Map;
};